import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var TopicListComponent = /** @class */ (function () {
    function TopicListComponent(dashboardService, errorHandlerService, route, router) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.route = route;
        this.router = router;
        this.topiclist = [];
        this.topicDashboard = {};
        this.moretopiclist = [];
        this.topicsearch = {};
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.apiSubscriber1 = null;
        this.apiSubscriber2 = null;
        this.apiSubscriberAll = null;
        this.apiSubscriber1 = this.dashboardService.topicList();
        this.apiSubscriber2 = this.dashboardService.topicDashboard();
        this.apiSubscriberAll = this.apiSubscriber1.merge(this.apiSubscriber2);
    }
    TopicListComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    TopicListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSearchExecuted = false;
        this.showSpinner = true;
        var apiCall1 = false;
        var apiCall2 = false;
        this.apiSubscriberAll.subscribe(function (data) {
            if (data.callName === 'topicList') {
                _this.topiclist = data;
                apiCall1 = true;
                console.log(_this.topiclist);
            }
            else {
                _this.topicDashboard = data;
                apiCall2 = true;
                console.log(_this.topicDashboard);
            }
            // Stop Spinner
            if (apiCall1 == true && apiCall2 == true) {
                _this.showSpinner = false;
            }
        }, function (error) {
            console.log(error);
            _this.handleError(error);
        });
        /*this.dashboardService.topicList().subscribe(
          data => {
            this.topiclist = data;
            console.log(this.topiclist);
          },
          error => {this.handleError(error);
          }
        );
    
       this.dashboardService.topicDashboard().subscribe(
          data => {
            this.topicDashboard = data;
            console.log(this.topicDashboard);
          },
          error => {
            this.handleError(error);
          }
        );*/
    };
    TopicListComponent.prototype.loadMoreTopicList = function () {
        var _this = this;
        this.showSpinner = true;
        if (!this.isSearchExecuted) {
            this.dashboardService.moretopicList().subscribe(function (data) {
                data.forEach(function (element) {
                    _this.topiclist.push(element);
                });
                _this.showSpinner = false;
            }, function (error) { _this.handleError(error); });
        }
        else {
            this.createTopicSearchRequest();
            this.dashboardService.moretopicSearch(this.topicsearch).subscribe(function (data) {
                data.forEach(function (element) {
                    _this.topiclist.push(element);
                });
                _this.showSpinner = false;
            }, function (error) { _this.handleError(error); });
        }
    };
    TopicListComponent.prototype.createTopicSearchRequest = function () {
        this.isSearchExecuted = true;
        this.topicsearch.isFilterByAlumniRequired = (this.topicsearch.isFilterByAlumniRequired != undefined) ? this.topicsearch.isFilterByAlumniRequired : false;
        this.topicsearch.isFilterByCorporateRequired = (this.topicsearch.isFilterByCorporateRequired != undefined) ? this.topicsearch.isFilterByCorporateRequired : false;
        this.topicsearch.isFilterByOPenTOpicRequried = (this.topicsearch.isFilterByOPenTOpicRequried != undefined) ? this.topicsearch.isFilterByOPenTOpicRequried : false;
        this.topicsearch.isFilterByPrivateTopicRequried = (this.topicsearch.isFilterByPrivateTopicRequried != undefined) ? this.topicsearch.isFilterByPrivateTopicRequried : false;
        this.topicsearch.isFilterByNameRequried = (this.topicsearch.topicName != undefined) ? true : false;
        this.topicsearch.isFilterByInterestedTopicsRequired = (this.topicsearch.isFilterByInterestedTopicsRequired != undefined) ? this.topicsearch.isFilterByInterestedTopicsRequired : false;
        console.log(this.topicsearch);
    };
    TopicListComponent.prototype.searchTopic = function () {
        var _this = this;
        this.showSpinner = true;
        this.createTopicSearchRequest();
        this.dashboardService.searchTopicList(this.topicsearch).subscribe(function (data) {
            _this.topiclist = data;
            console.log(_this.topiclist);
            _this.showSpinner = false;
        }, function (error) { _this.handleError(error); });
    };
    TopicListComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return TopicListComponent;
}());
export { TopicListComponent };
//# sourceMappingURL=topiclist.component.js.map